export const KYC_ATTEMPT_STAGES = Object.freeze({
  DOCUMENT: "document",
  FACE: "face",
  ADDRESS_PROOF: "addressProof",
});

export const KYC_ATTEMPT_STATUS = Object.freeze({
  CAPTURE: "CAPTURE",
  SUBMIT_ATTEMPT_1: "SUBMIT_ATTEMPT_1",
  FAILED_FIRST_ATTEMPT: "FAILED_FIRST_ATTEMPT",
  SUBMIT_ATTEMPT_2: "SUBMIT_ATTEMPT_2",
  COMPLETED: "COMPLETED",
});

export const requiresSecondSubmission = (stage) =>
  stage === KYC_ATTEMPT_STAGES.FACE ||
  stage === KYC_ATTEMPT_STAGES.ADDRESS_PROOF;

const LEGACY_STORAGE_KEYS = Object.freeze({
  [KYC_ATTEMPT_STAGES.DOCUMENT]: "isFirstSubmitDocments",
  [KYC_ATTEMPT_STAGES.FACE]: "isFirstSubmitFace",
  [KYC_ATTEMPT_STAGES.ADDRESS_PROOF]: "isFirstSubmitProof",
});

const readLegacyAttempt = (stage) => {
  try {
    return Number(localStorage.getItem(LEGACY_STORAGE_KEYS[stage]) || 0) > 0
      ? 1
      : 0;
  } catch {
    return 0;
  }
};

const createStageAttempt = (stage) => ({
  completedAttempts: requiresSecondSubmission(stage)
    ? readLegacyAttempt(stage)
    : 0,
  status: KYC_ATTEMPT_STATUS.CAPTURE,
});

export const createKycAttemptState = () => ({
  [KYC_ATTEMPT_STAGES.DOCUMENT]: createStageAttempt(
    KYC_ATTEMPT_STAGES.DOCUMENT,
  ),
  [KYC_ATTEMPT_STAGES.FACE]: createStageAttempt(KYC_ATTEMPT_STAGES.FACE),
  [KYC_ATTEMPT_STAGES.ADDRESS_PROOF]: createStageAttempt(
    KYC_ATTEMPT_STAGES.ADDRESS_PROOF,
  ),
});

export const legacyAttemptStorage = {
  markFirstAttempt(stage) {
    const storageKey = LEGACY_STORAGE_KEYS[stage];
    if (!storageKey) return;

    try {
      localStorage.setItem(storageKey, "1");
    } catch {
      // The in-memory state machine still works when storage is unavailable.
    }
  },
};
